import React from "react";
import {styled, FormControl } from "@mui/material";

const MultiSelectField = styled(FormControl)({
  background: "#fff",
  borderRadius: "10px",
  border: "1px solid #e6e7e9",
  margin: 0
});
export default MultiSelectField;
